import { authorizedFetch, baseUrl, removeEmpty } from './base';
import queryString from 'query-string';

async function listing(params = {}) {
  const path = `${baseUrl}/console/api/super_admin/credits?${queryString.stringify(
    removeEmpty(params)
  )}`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

async function reactive(id) {
  const path = `${baseUrl}/console/api/super_admin/credits/reactivate/${id}`;
  return await authorizedFetch(path, {
    method: 'GET'
  });
}

const creditApis = { listing, reactive };

export default creditApis;
